import { Schema } from "effect";
import { BulkSupportTicketAction } from "../shopper-ai/conversation/bulk-support-ticket-action";

export const BulkSupportTicketActionProgressStatus = Schema.Literal(
  "started",
  "processing",
  "completed",
  "failed",
);
export type BulkSupportTicketActionProgressStatus =
  typeof BulkSupportTicketActionProgressStatus.Type;

export const BulkSupportTicketActionProgressNotification = Schema.Struct({
  _tag: Schema.Literal("bulkSupportTicketActionProgress"),
  workflowId: Schema.String,
  action: BulkSupportTicketAction,
  status: BulkSupportTicketActionProgressStatus,
  totalCount: Schema.Number,
  processedCount: Schema.Number,
  failedCount: Schema.Number,
});
export type BulkSupportTicketActionProgressNotification =
  typeof BulkSupportTicketActionProgressNotification.Type;

export const BrowserNotification = Schema.Struct({
  _tag: Schema.Literal("browserNotification"),
  notificationInstanceId: Schema.String,
  taskId: Schema.String,
  title: Schema.String,
  body: Schema.String,
  route: Schema.String,
  tag: Schema.String,
  requireInteraction: Schema.Boolean,
});
export type BrowserNotification = typeof BrowserNotification.Type;

export const UserNotification = Schema.Union(
  BulkSupportTicketActionProgressNotification,
  BrowserNotification,
);
export type UserNotification = typeof UserNotification.Type;
